import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let rawEscapeExample = `echo -e "\\033[31mThis is red\\033[0m"
echo -e "\\033[1;32mBold green\\033[0m"`

let tputExample = `red=$(tput setaf 1)
green=$(tput setaf 2)
bold=$(tput bold)
reset=$(tput sgr0)

echo "$\{bold}$\{green}Success$\{reset}: deploy finished"
echo "$\{red}Error$\{reset}: connection refused"`

let helperExample = `log_error() {
    echo "$(tput setaf 1)[ERROR]$(tput sgr0) $*" >&2
}
log_info() {
    echo "$(tput setaf 2)[INFO]$(tput sgr0) $*"
}

log_info "starting backup"
log_error "disk full"`

export default function AnsiColors() {
    return (
        <div className={globalStyles.article}>
            <h1>ANSI color output</h1>
            <p>Terminal color comes from escape sequences — raw ones work everywhere ANSI is supported, but
                <code> tput</code> is portable across terminal types and easier to read.</p>

            <h3>Raw escape codes</h3>
            <SyntaxHighlighter
                children={rawEscapeExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '400px'}}>
                    <thead>
                    <tr>
                        <th>Code</th>
                        <th>Color</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>30-37</code></td>
                        <td>Foreground: black, red, green, yellow, blue, magenta, cyan, white</td>
                    </tr>
                    <tr>
                        <td><code>90-97</code></td>
                        <td>Bright foreground versions of the same</td>
                    </tr>
                    <tr>
                        <td><code>1</code></td>
                        <td>Bold</td>
                    </tr>
                    <tr>
                        <td><code>0</code></td>
                        <td>Reset all attributes</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>tput (preferred)</h3>
            <p>Reads the terminal's own <code>terminfo</code> database, so it degrades gracefully on
                terminals without color support instead of printing garbage escape codes.</p>
            <SyntaxHighlighter
                children={tputExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Reusable log helpers</h3>
            <SyntaxHighlighter
                children={helperExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
